import { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Sidebar from "@/components/sidebar";
import Topbar from "@/components/Topbar";

export default function AdminLayout() {
  const {pathname} = useLocation();
  const [environmentEpoch, setEnvironmentEpoch] = useState(0);
  useEffect(() => {
    const reset = () => setEnvironmentEpoch(value => value + 1);
    window.addEventListener("admin-environment-changed", reset);
    return () => window.removeEventListener("admin-environment-changed", reset);
  }, []);
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="flex h-screen bg-surface overflow-hidden font-sans">
      {/* Desktop Sidebar - always visible */}
      <div className="hidden lg:block shrink-0">
        <Sidebar onClose={() => setSidebarOpen(false)} />
      </div>

      {/* Mobile Sidebar - overlay drawer */}
      <div
        className={`fixed inset-0 z-40 lg:hidden transition-opacity duration-300 ${
          sidebarOpen ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"
        }`}
      >
        <div
          className="absolute inset-0 bg-black/40"
          onClick={() => setSidebarOpen(false)}
        />
        <div
          className={`absolute inset-y-0 left-0 w-[280px] transform transition-transform duration-300 ${
            sidebarOpen ? "translate-x-0" : "-translate-x-full"
          }`}
        >
          <Sidebar onClose={() => setSidebarOpen(false)} />
        </div>
      </div>

      {/* Main Content */}
      <div className="flex-1 flex flex-col min-w-0 overflow-hidden">
        <Topbar onMenuClick={() => setSidebarOpen(true)} />
        <main className="flex-1 overflow-y-auto p-4 md:p-6 lg:p-8">
          <Outlet key={pathname.startsWith("/forex") ? `forex-${environmentEpoch}` : "other"} />
        </main>
      </div>
    </div>
  );
}